module.exports = __webpack_public_path__ + "img/waiting-on-photo@1x.dc4bfa63.webp";